<template>
  <Teleport to="body">
    <template v-if="visivel">
      <div class="modal fade show d-block" tabindex="-1" @click.self="fechar">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable crm-contato-modal">
          <div class="modal-content border-0 shadow-lg">
            <!-- Header -->
            <div class="modal-header border-bottom-0 pb-0">
              <div>
                <h5 class="modal-title fw-bold mb-1">{{ contato ? 'Editar Contato' : 'Novo Contato' }}</h5>
                <p class="text-muted fs-13 mb-0">Preencha os dados e selecione os etiquetas</p>
              </div>
              <button type="button" class="btn-close" @click="fechar"></button>
            </div>

            <form @submit.prevent="salvar">
              <div class="modal-body pt-3">
                <BRow class="g-0">
                  <!-- Coluna esquerda: Etiquetas -->
                  <BCol cols="12" lg="4" class="crm-rotulos-panel">
                    <div class="crm-rotulos-inner">
                      <div class="d-flex align-items-center mb-3">
                        <i class="ri-price-tag-3-line fs-18 text-primary me-2"></i>
                        <h6 class="mb-0 fw-semibold">Etiquetas</h6>
                        <span v-if="rotulosSelecionados.length" class="badge bg-primary rounded-pill ms-auto">
                          {{ rotulosSelecionados.length }}
                        </span>
                      </div>

                      <!-- Busca de etiquetas -->
                      <div class="search-box mb-3">
                        <input
                          v-model="buscaRotulo"
                          type="text"
                          class="form-control form-control-sm bg-light border-0"
                          placeholder="Buscar etiquetas..."
                        />
                        <i class="ri-search-line search-icon"></i>
                      </div>

                      <!-- Lista de etiquetas -->
                      <div class="crm-rotulos-lista">
                        <div v-if="carregandoRotulos" class="text-center py-3">
                          <BSpinner small variant="primary" />
                        </div>
                        <template v-else>
                          <div
                            v-for="rotulo in rotulosFiltrados"
                            :key="rotulo.id"
                            class="crm-rotulo-item"
                            :class="{ 'crm-rotulo-ativo': isRotuloSelecionado(rotulo.id) }"
                            @click="toggleRotulo(rotulo)"
                          >
                            <span
                              class="crm-rotulo-cor"
                              :style="{ backgroundColor: rotulo.cor_referencia || '#6c757d' }"
                            ></span>
                            <span class="crm-rotulo-nome">{{ rotulo.nome }}</span>
                            <span v-if="rotulo.categoria" class="crm-rotulo-cat">{{ rotulo.categoria }}</span>
                            <i
                              v-if="isRotuloSelecionado(rotulo.id)"
                              class="ri-check-line text-primary ms-auto"
                            ></i>
                          </div>

                          <div v-if="!rotulosFiltrados.length && buscaRotulo" class="text-center py-3">
                            <p class="text-muted fs-13 mb-2">Nenhuma etiqueta encontrado</p>
                            <button
                              type="button"
                              class="btn btn-sm btn-soft-primary"
                              @click="abrirCriacaoRapida(buscaRotulo)"
                            >
                              <i class="ri-add-line me-1"></i> Criar "{{ buscaRotulo }}"
                            </button>
                          </div>

                          <div v-if="!rotulosDisponiveis.length && !buscaRotulo" class="text-center py-3">
                            <p class="text-muted fs-13 mb-0">Nenhuma etiqueta cadastrada</p>
                          </div>
                        </template>
                      </div>

                      <!-- Etiquetas selecionados (chips) -->
                      <div v-if="rotulosSelecionados.length" class="crm-rotulos-selecionados mt-3">
                        <label class="form-label fs-12 text-uppercase text-muted fw-semibold mb-2">Selecionados</label>
                        <div class="d-flex flex-wrap gap-1">
                          <span
                            v-for="rotulo in rotulosSelecionados"
                            :key="rotulo.id"
                            class="crm-rotulo-chip"
                            :style="{
                              backgroundColor: (rotulo.cor_referencia || '#6c757d') + '20',
                              color: rotulo.cor_referencia || '#6c757d',
                              borderColor: (rotulo.cor_referencia || '#6c757d') + '40',
                            }"
                          >
                            {{ rotulo.nome }}
                            <i class="ri-close-line ms-1 crm-chip-remover" @click.stop="toggleRotulo(rotulo)"></i>
                          </span>
                        </div>
                      </div>

                      <!-- Criar etiqueta inline -->
                      <div class="crm-criar-rotulo mt-3">
                        <button
                          v-if="!criandoRotulo"
                          type="button"
                          class="btn btn-sm btn-ghost-primary w-100 d-flex align-items-center justify-content-center gap-1"
                          @click="criandoRotulo = true"
                        >
                          <i class="ri-add-circle-line"></i> Criar nova etiqueta
                        </button>

                        <div v-else class="crm-rotulo-form">
                          <div class="mb-2">
                            <input
                              ref="inputNovoRotulo"
                              v-model="novoRotulo.nome"
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="Nome do etiqueta"
                              :class="{ 'is-invalid': erroNovoRotulo }"
                              @keydown.enter.prevent="criarRotuloInline"
                              @keydown.escape="cancelarCriacaoRotulo"
                            />
                            <div v-if="erroNovoRotulo" class="invalid-feedback">{{ erroNovoRotulo }}</div>
                          </div>
                          <div class="d-flex align-items-center gap-2 mb-2">
                            <input
                              v-model="novoRotulo.cor_referencia"
                              type="color"
                              class="form-control form-control-color form-control-sm crm-color-picker"
                              title="Cor do etiqueta"
                            />
                            <input
                              v-model="novoRotulo.categoria"
                              type="text"
                              class="form-control form-control-sm flex-grow-1"
                              placeholder="Categoria (opcional)"
                            />
                          </div>
                          <div class="d-flex gap-2">
                            <button
                              type="button"
                              class="btn btn-sm btn-primary flex-grow-1"
                              :disabled="salvandoRotulo"
                              @click="criarRotuloInline"
                            >
                              <BSpinner v-if="salvandoRotulo" small class="me-1" />
                              Criar
                            </button>
                            <button
                              type="button"
                              class="btn btn-sm btn-ghost-dark"
                              @click="cancelarCriacaoRotulo"
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </BCol>

                  <!-- Coluna direita: Formulário -->
                  <BCol cols="12" lg="8" class="crm-form-panel">
                    <div class="crm-form-inner">
                      <!-- Seção: Dados Pessoais -->
                      <div class="crm-secao mb-4">
                        <div class="crm-secao-header">
                          <i class="ri-user-3-line"></i>
                          <span>Dados pessoais</span>
                        </div>
                        <BRow class="g-3">
                          <BCol cols="12" md="6">
                            <label class="form-label fs-13">Nome <span class="text-danger">*</span></label>
                            <input v-model="form.nome" type="text" class="form-control text-uppercase" :class="{ 'is-invalid': erros.nome }" />
                            <div v-if="erros.nome" class="invalid-feedback">{{ erros.nome }}</div>
                          </BCol>
                          <BCol cols="12" md="6">
                            <label class="form-label fs-13">Sobrenome</label>
                            <input v-model="form.sobrenome" type="text" class="form-control text-uppercase" />
                          </BCol>
                          <BCol cols="12" md="4">
                            <label class="form-label fs-13">Documento (CPF/CNPJ)</label>
                            <input v-model="form.documento" type="text" class="form-control" />
                          </BCol>
                          <BCol cols="12" md="4">
                            <label class="form-label fs-13">Data de Nascimento</label>
                            <AppDatepicker v-model="form.data_nascimento" mode="date" placeholder="dd/mm/aaaa" />
                          </BCol>
                          <BCol cols="12" md="4">
                            <label class="form-label fs-13">Status</label>
                            <Multiselect
                              v-model="form.status_contato"
                              :options="[
                                { value: 'ativo', label: 'Ativo' },
                                { value: 'inativo', label: 'Inativo' },
                                { value: 'bloqueado', label: 'Bloqueado' },
                              ]"
                              label="label"
                              value-prop="value"
                              :searchable="false"
                              :can-clear="false"
                              :can-deselect="false"
                            />
                          </BCol>
                        </BRow>
                      </div>

                      <!-- Seção: Contato -->
                      <div class="crm-secao mb-4">
                        <div class="crm-secao-header">
                          <i class="ri-phone-line"></i>
                          <span>Contato</span>
                        </div>
                        <BRow class="g-3">
                          <BCol cols="12" md="6">
                            <label class="form-label fs-13">Telefone Principal <span class="text-danger">*</span></label>
                            <input
                              v-model="form.telefonePrincipal"
                              v-mask="['(##) ####-####', '(##) #####-####']"
                              type="text"
                              class="form-control"
                              placeholder="(00) 00000-0000"
                              :class="{ 'is-invalid': erros.telefonePrincipal }"
                            />
                            <div v-if="erros.telefonePrincipal" class="invalid-feedback">{{ erros.telefonePrincipal }}</div>
                          </BCol>
                          <BCol cols="12" md="6">
                            <label class="form-label fs-13">E-mail</label>
                            <input v-model="form.email" type="email" class="form-control" />
                          </BCol>
                        </BRow>
                      </div>

                      <!-- Seção: Endereço (colapsável) -->
                      <div class="crm-secao mb-4">
                        <div
                          class="crm-secao-header crm-secao-toggle"
                          @click="secaoEnderecoAberta = !secaoEnderecoAberta"
                        >
                          <i class="ri-map-pin-line"></i>
                          <span>Endereço</span>
                          <i
                            class="ms-auto fs-16"
                            :class="secaoEnderecoAberta ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"
                          ></i>
                        </div>
                        <div v-show="secaoEnderecoAberta">
                          <BRow class="g-3">
                            <BCol cols="12" md="4">
                              <label class="form-label fs-13">CEP</label>
                              <div class="position-relative">
                                <input
                                  v-model="form.cep"
                                  v-mask="'#####-###'"
                                  type="text"
                                  class="form-control"
                                  placeholder="00000-000"
                                  @input="onCepInput"
                                />
                                <span v-if="carregandoCep" class="position-absolute top-50 end-0 translate-middle-y pe-3">
                                  <BSpinner small />
                                </span>
                              </div>
                            </BCol>
                            <BCol cols="12" md="4">
                              <label class="form-label fs-13">Estado</label>
                              <Multiselect
                                v-model="form.estado"
                                :options="opcoesEstado"
                                label="label"
                                value-prop="value"
                                :searchable="true"
                                :can-clear="true"
                                :can-deselect="true"
                                placeholder="Selecione"
                                @change="onEstadoChange"
                              />
                            </BCol>
                            <BCol cols="12" md="4">
                              <label class="form-label fs-13">Cidade</label>
                              <Multiselect
                                v-model="form.cidade"
                                :options="opcoesCidade"
                                label="label"
                                value-prop="value"
                                :searchable="true"
                                :can-clear="true"
                                :can-deselect="true"
                                :disabled="!form.estado || carregandoCidades"
                                placeholder="Selecione"
                              />
                            </BCol>
                            <BCol cols="12" md="4">
                              <label class="form-label fs-13">Bairro</label>
                              <input v-model="form.bairro" type="text" class="form-control text-uppercase" />
                            </BCol>
                            <BCol cols="12" md="5">
                              <label class="form-label fs-13">Logradouro</label>
                              <input v-model="form.logradouro" type="text" class="form-control text-uppercase" />
                            </BCol>
                            <BCol cols="6" md="3">
                              <label class="form-label fs-13">Número</label>
                              <input v-model="form.numero" type="text" class="form-control text-uppercase" />
                            </BCol>
                            <BCol cols="12">
                              <label class="form-label fs-13">Complemento</label>
                              <input v-model="form.complemento" type="text" class="form-control text-uppercase" />
                            </BCol>
                          </BRow>
                        </div>
                      </div>

                      <!-- Seção: Campos Personalizados -->
                      <div v-if="camposOrdenados.length" class="crm-secao">
                        <div
                          class="crm-secao-header crm-secao-toggle"
                          @click="secaoCamposAberta = !secaoCamposAberta"
                        >
                          <i class="ri-list-settings-line"></i>
                          <span>Campos personalizados</span>
                          <span class="badge bg-warning-subtle text-warning rounded-pill ms-2">{{ camposOrdenados.length }}</span>
                          <i
                            class="ms-auto fs-16"
                            :class="secaoCamposAberta ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"
                          ></i>
                        </div>
                        <div v-show="secaoCamposAberta">
                          <BRow class="g-3">
                            <BCol v-for="campo in camposOrdenados" :key="campo.id" cols="12" md="6">
                              <CampoAdicionalRenderer
                                v-model="camposPersonalizados[campo.id]"
                                :campo="campo"
                                :error="erros[`campo_${campo.id}`]"
                              />
                            </BCol>
                          </BRow>
                        </div>
                      </div>
                    </div>
                  </BCol>
                </BRow>

                <!-- Alerta de mensagem -->
                <div v-if="mensagem" class="alert mt-3 mb-0" :class="mensagem.tipo === 'erro' ? 'alert-danger' : 'alert-success'">
                  <i :class="mensagem.tipo === 'erro' ? 'ri-error-warning-line' : 'ri-check-line'" class="me-2 align-middle"></i>
                  {{ mensagem.texto }}
                </div>
              </div>

              <!-- Footer -->
              <div class="modal-footer border-top-0">
                <BButton variant="ghost-dark" @click="fechar">Cancelar</BButton>
                <BButton type="submit" variant="primary" :disabled="salvando" class="px-4">
                  <BSpinner v-if="salvando" small class="me-1" />
                  {{ salvando ? 'Salvando...' : 'Salvar' }}
                </BButton>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show" @click="fechar"></div>
    </template>
  </Teleport>
</template>

<script>
import axios from 'axios';
import { api, sucesso } from '@/helpers/common/api';
import CampoAdicionalRenderer from '@/components/crm/contato/CampoAdicionalRenderer.vue';

const emptyForm = () => ({
  nome: '',
  sobrenome: '',
  documento: '',
  telefonePrincipal: '',
  email: '',
  data_nascimento: '',
  status_contato: 'ativo',
  cep: '',
  estado: '',
  cidade: '',
  logradouro: '',
  numero: '',
  bairro: '',
  complemento: '',
});

export default {
  name: 'ContatoModal',
  components: { CampoAdicionalRenderer },
  props: {
    visivel: { type: Boolean, default: false },
    contato: { type: Object, default: null },
    camposDisponiveis: { type: Array, default: () => [] },
  },
  emits: ['fechar', 'salvo'],
  data() {
    return {
      form: emptyForm(),
      camposPersonalizados: {},
      erros: {},
      salvando: false,
      mensagem: null,
      carregandoCep: false,
      carregandoCidades: false,
      estadosBrasil: [],
      cidadesEstado: [],
      cepTimer: null,
      // Etiquetas
      rotulosDisponiveis: [],
      rotulosIdsOriginal: [],
      rotulosIdsSelecionados: [],
      buscaRotulo: '',
      carregandoRotulos: false,
      criandoRotulo: false,
      salvandoRotulo: false,
      erroNovoRotulo: '',
      novoRotulo: { nome: '', cor_referencia: '#3b82f6', categoria: '' },
      // Seções colapsáveis
      secaoEnderecoAberta: true,
      secaoCamposAberta: true,
    };
  },
  watch: {
    visivel: {
      handler(val) {
        if (val) {
          this.hidratarFormulario();
          this.carregarRotulosDisponiveis();
        }
      },
    },
    contato: {
      immediate: true,
      handler() {
        this.hidratarFormulario();
      },
    },
    camposDisponiveis: {
      deep: true,
      handler() {
        this.hidratarFormulario();
      },
    },
  },
  computed: {
    camposOrdenados() {
      return [...this.camposDisponiveis].sort((left, right) => Number(left.ordem_exibicao || 0) - Number(right.ordem_exibicao || 0));
    },
    opcoesEstado() {
      return this.estadosBrasil.map((estado) => ({
        value: estado.sigla,
        label: `${estado.sigla} - ${estado.nome}`,
      }));
    },
    opcoesCidade() {
      return this.cidadesEstado.map((cidade) => ({ value: String(cidade).toUpperCase(), label: String(cidade).toUpperCase() }));
    },
    rotulosFiltrados() {
      if (!this.buscaRotulo) return this.rotulosDisponiveis;
      const termo = this.buscaRotulo.toLowerCase();
      return this.rotulosDisponiveis.filter(
        (r) => r.nome.toLowerCase().includes(termo) || (r.categoria || '').toLowerCase().includes(termo),
      );
    },
    rotulosSelecionados() {
      return this.rotulosDisponiveis.filter((r) => this.rotulosIdsSelecionados.includes(r.id));
    },
  },
  async created() {
    await this.carregarEstados();
  },
  methods: {
    // === Etiquetas ===
    async carregarRotulosDisponiveis() {
      this.carregandoRotulos = true;
      try {
        const resultado = await api.read('/rotulo?limit=9999');
        if (resultado && typeof resultado === 'object') {
          const lista = Array.isArray(resultado)
            ? resultado
            : Array.isArray(resultado.data)
              ? resultado.data
              : Array.isArray(resultado.data?.data)
                ? resultado.data.data
                : [];
          this.rotulosDisponiveis = lista;
        }
      } finally {
        this.carregandoRotulos = false;
      }
    },
    isRotuloSelecionado(id) {
      return this.rotulosIdsSelecionados.includes(id);
    },
    toggleRotulo(rotulo) {
      const idx = this.rotulosIdsSelecionados.indexOf(rotulo.id);
      if (idx >= 0) {
        this.rotulosIdsSelecionados.splice(idx, 1);
      } else {
        this.rotulosIdsSelecionados.push(rotulo.id);
      }
    },
    abrirCriacaoRapida(nome) {
      this.criandoRotulo = true;
      this.novoRotulo.nome = nome;
      this.$nextTick(() => {
        this.$refs.inputNovoRotulo?.focus();
      });
    },
    cancelarCriacaoRotulo() {
      this.criandoRotulo = false;
      this.novoRotulo = { nome: '', cor_referencia: '#3b82f6', categoria: '' };
      this.erroNovoRotulo = '';
    },
    async criarRotuloInline() {
      const nome = String(this.novoRotulo.nome || '').trim();
      if (!nome) {
        this.erroNovoRotulo = 'Nome é obrigatório.';
        return;
      }
      this.erroNovoRotulo = '';
      this.salvandoRotulo = true;
      try {
        const resp = await axios.post('/rotulo', {
          nome,
          cor_referencia: this.novoRotulo.cor_referencia || '#3b82f6',
          categoria: this.novoRotulo.categoria || null,
        });
        const novo = resp?.data?.data ?? resp?.data;
        if (novo && novo.id) {
          this.rotulosDisponiveis.push(novo);
          this.rotulosIdsSelecionados.push(novo.id);
          this.cancelarCriacaoRotulo();
          this.buscaRotulo = '';
        }
      } catch (e) {
        this.erroNovoRotulo = e?.response?.data?.error
          || (e?.response?.data?.issues && e.response.data.issues.map((i) => i.message).join(', '))
          || e?.message
          || 'Falha ao criar etiqueta.';
      } finally {
        this.salvandoRotulo = false;
      }
    },
    async sincronizarRotulos(contatoId) {
      const idsOriginais = new Set(this.rotulosIdsOriginal);
      const idsAtuais = new Set(this.rotulosIdsSelecionados);

      const adicionar = [...idsAtuais].filter((id) => !idsOriginais.has(id));
      const remover = [...idsOriginais].filter((id) => !idsAtuais.has(id));

      const nomesAdicionar = adicionar
        .map((id) => this.rotulosDisponiveis.find((r) => r.id === id)?.nome)
        .filter(Boolean);
      const nomesRemover = remover
        .map((id) => this.rotulosDisponiveis.find((r) => r.id === id)?.nome)
        .filter(Boolean);

      if (nomesAdicionar.length) {
        await api.create('/contato/rotulo/lote', {
          contatoIds: [contatoId],
          rotulos: nomesAdicionar,
          operacao: 'adicionar',
        });
      }
      if (nomesRemover.length) {
        await api.create('/contato/rotulo/lote', {
          contatoIds: [contatoId],
          rotulos: nomesRemover,
          operacao: 'remover',
        });
      }
    },

    // === Utilitários ===
    apenasDigitos(valor) {
      return String(valor || '').replace(/\D/g, '');
    },
    removerDDI(valor) {
      const digitos = String(valor || '').replace(/\D/g, '');
      if (digitos.startsWith('55') && (digitos.length === 12 || digitos.length === 13)) {
        return digitos.slice(2);
      }
      return valor || '';
    },
    async carregarEstados() {
      try {
        const response = await fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados');
        const data = await response.json();
        this.estadosBrasil = Array.isArray(data)
          ? data
              .map((item) => ({ sigla: item.sigla, nome: item.nome }))
              .sort((a, b) => String(a.nome).localeCompare(String(b.nome)))
          : [];
      } catch (_error) {
        this.estadosBrasil = [];
      }
    },
    async carregarCidades(uf) {
      if (!uf) {
        this.cidadesEstado = [];
        return;
      }

      this.carregandoCidades = true;
      try {
        const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
        const data = await response.json();
        this.cidadesEstado = Array.isArray(data)
          ? data.map((item) => item.nome).sort((a, b) => String(a).localeCompare(String(b)))
          : [];
      } catch (_error) {
        this.cidadesEstado = [];
      } finally {
        this.carregandoCidades = false;
      }
    },
    async onEstadoChange(uf) {
      if (!uf) {
        this.form.estado = '';
        this.form.cidade = '';
        this.cidadesEstado = [];
        return;
      }

      this.form.estado = uf;
      this.form.cidade = '';
      await this.carregarCidades(uf);
    },
    async buscarEnderecoPorCep() {
      const cep = this.apenasDigitos(this.form.cep);
      if (cep.length !== 8) return;

      this.carregandoCep = true;
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        const data = await response.json();
        if (!data || data.erro) return;

        this.form.logradouro = (data.logradouro || this.form.logradouro || '').toUpperCase();
        this.form.bairro = (data.bairro || this.form.bairro || '').toUpperCase();

        if (data.uf) {
          this.form.estado = data.uf.toUpperCase();
          await this.carregarCidades(data.uf.toUpperCase());
        }

        if (data.localidade) {
          this.form.cidade = data.localidade.toUpperCase();
        }
      } catch (_error) {
        // Sem bloqueio de fluxo caso o serviço externo esteja indisponível.
      } finally {
        this.carregandoCep = false;
      }
    },
    onCepInput() {
      clearTimeout(this.cepTimer);
      this.cepTimer = setTimeout(() => {
        this.buscarEnderecoPorCep();
      }, 350);
    },
    hidratarFormulario() {
      if (this.contato) {
        const tel = (this.contato.canais || []).find((c) => c.tipo_canal === 'telefone' && c.principal);
        const email = (this.contato.canais || []).find((c) => c.tipo_canal === 'email');
        this.form = {
          nome: this.contato.nome || '',
          sobrenome: this.contato.sobrenome || '',
          documento: this.contato.documento || '',
          telefonePrincipal: this.removerDDI(tel?.valor_canal) || '',
          email: email?.valor_canal || '',
          data_nascimento: this.contato.data_nascimento || '',
          status_contato: this.contato.status_contato || 'ativo',
          cep: this.contato.cep || '',
          estado: this.contato.estado || '',
          cidade: this.contato.cidade || '',
          logradouro: this.contato.logradouro || '',
          numero: this.contato.numero || '',
          bairro: this.contato.bairro || '',
          complemento: this.contato.complemento || '',
        };

        const idsRotulos = (this.contato.rotulos || []).map((r) => r.id);
        this.rotulosIdsSelecionados = [...idsRotulos];
        this.rotulosIdsOriginal = [...idsRotulos];

        if (this.form.estado) this.carregarCidades(this.form.estado);

        // Endereço sempre expandido
        this.secaoEnderecoAberta = true;
      } else {
        this.form = emptyForm();
        this.cidadesEstado = [];
        this.rotulosIdsSelecionados = [];
        this.rotulosIdsOriginal = [];
        this.secaoEnderecoAberta = true;
      }

      const valores = {};
      this.camposOrdenados.forEach((campo) => {
        const existente = (this.contato?.camposPersonalizados || []).find((item) => item.campopersonalizado_id === campo.id);
        if (existente) valores[campo.id] = existente.valor;
        else if (campo.tipo_campo === 'checkbox') valores[campo.id] = false;
        else if (campo.tipo_campo === 'multiselect_tags') valores[campo.id] = [];
        else if (campo.tipo_campo === 'color') valores[campo.id] = '#1f6feb';
        else valores[campo.id] = null;
      });

      this.camposPersonalizados = valores;
      this.erros = {};
      this.mensagem = null;
      this.buscaRotulo = '';
      this.cancelarCriacaoRotulo();
    },
    validar() {
      this.erros = {};
      if (!String(this.form.nome || '').trim()) {
        this.erros.nome = 'Nome é obrigatório.';
      }
      if (!this.form.telefonePrincipal) {
        this.erros.telefonePrincipal = 'Telefone principal é obrigatório.';
      }

      this.camposOrdenados.forEach((campo) => {
        const valor = this.camposPersonalizados[campo.id];
        const vazio = valor === null || valor === undefined || valor === '' || (Array.isArray(valor) && !valor.length);
        if (campo.tipo_campo === 'checkbox' && campo.obrigatorio && valor !== true) {
          this.erros[`campo_${campo.id}`] = `Marque o campo ${campo.nome_exibicao}.`;
          return;
        }
        if (campo.obrigatorio && vazio) {
          this.erros[`campo_${campo.id}`] = `Preencha o campo ${campo.nome_exibicao}.`;
        }
      });

      return Object.keys(this.erros).length === 0;
    },
    montarPayload() {
      const canais = [{ tipo_canal: 'telefone', valor_canal: this.form.telefonePrincipal, principal: true }];
      if (this.form.email) canais.push({ tipo_canal: 'email', valor_canal: this.form.email, principal: false });

      return {
        nome: String(this.form.nome || '').trim(),
        sobrenome: this.form.sobrenome || null,
        documento: this.form.documento,
        status_contato: this.form.status_contato || 'ativo',
        cep: this.form.cep || null,
        estado: this.form.estado || null,
        cidade: this.form.cidade || null,
        logradouro: this.form.logradouro || null,
        numero: this.form.numero || null,
        bairro: this.form.bairro || null,
        complemento: this.form.complemento || null,
        data_nascimento: this.form.data_nascimento || null,
        canais,
        camposPersonalizados: this.camposOrdenados.map((campo) => ({
          campoPersonalizadoId: campo.id,
          valor: this.camposPersonalizados[campo.id],
        })),
      };
    },
    async salvar() {
      if (!this.validar()) return;
      this.salvando = true;
      this.mensagem = null;

      const payload = this.montarPayload();
      const result = this.contato
        ? await api.update(`/contato/${this.contato.id}`, payload)
        : await api.create('/contato', payload);

      if (result) {
        const contatoId = this.contato ? this.contato.id : result.id;
        await this.sincronizarRotulos(contatoId);
        sucesso();
        this.$emit('salvo', result);
        this.$emit('fechar');
      } else {
        this.mensagem = { tipo: 'erro', texto: 'Erro ao salvar contato. Verifique os dados.' };
      }

      this.salvando = false;
    },
    fechar() {
      this.$emit('fechar');
    },
  },
  unmounted() {
    clearTimeout(this.cepTimer);
  },
};
</script>

<style scoped>
.modal {
  z-index: 1055;
}
.modal-backdrop {
  z-index: 1040;
  cursor: pointer;
}

/* === Modal container === */
.crm-contato-modal {
  max-width: min(1100px, calc(100vw - 1rem));
}
.crm-contato-modal .modal-content {
  border-radius: 12px;
  overflow: hidden;
  /* Header e footer FIXOS; só o corpo rola. Sem isto, o <form> que envolve
     body+footer quebra o scroll do Bootstrap e o footer (botão Salvar) some
     fora da tela em resoluções menores. dvh evita corte pela barra do mobile. */
  display: flex;
  flex-direction: column;
  max-height: calc(100dvh - 2rem);
}
/* O <form> é o filho flex que segura body (rolável) + footer (fixo). */
.crm-contato-modal .modal-content > form {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.crm-contato-modal .modal-header,
.crm-contato-modal .modal-footer {
  flex-shrink: 0;
}
.crm-contato-modal .modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

/* === Painel de etiquetas (esquerda) === */
.crm-rotulos-panel {
  border-right: 1px solid var(--vz-border-color, #e9ebec);
}
.crm-rotulos-inner {
  padding: 1rem;
  display: flex;
  flex-direction: column;
}
.crm-rotulos-lista {
  max-height: 260px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.crm-rotulo-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.625rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s;
  user-select: none;
}
.crm-rotulo-item:hover {
  background-color: var(--vz-light, #f3f6f9);
}
.crm-rotulo-ativo {
  background-color: rgba(var(--vz-primary-rgb, 59, 130, 246), 0.08);
}
.crm-rotulo-cor {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.crm-rotulo-nome {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.crm-rotulo-cat {
  font-size: 11px;
  color: var(--vz-secondary-color, #878a99);
  margin-left: auto;
  white-space: nowrap;
}

/* === Chips de etiquetas selecionados === */
.crm-rotulo-chip {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  border: 1px solid;
  line-height: 1.4;
}
.crm-chip-remover {
  cursor: pointer;
  font-size: 14px;
  opacity: 0.6;
  transition: opacity 0.15s;
}
.crm-chip-remover:hover {
  opacity: 1;
}

/* === Formulário de criação rápida === */
.crm-rotulo-form {
  background: var(--vz-light, #f3f6f9);
  border-radius: 8px;
  padding: 0.75rem;
}
.crm-color-picker {
  width: 36px !important;
  min-width: 36px;
  height: 31px;
  padding: 2px;
  flex-shrink: 0;
}

/* === Painel do formulário (direita) === */
.crm-form-panel {
  /* sem borda extra neste lado */
}
.crm-form-inner {
  padding: 1rem 1rem 1rem 1.25rem;
}

/* === Seções do formulário === */
.crm-secao-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--vz-heading-color, #495057);
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--vz-border-color, #e9ebec);
}
.crm-secao-header i:first-child {
  font-size: 16px;
  color: var(--vz-primary, #405189);
}
.crm-secao-toggle {
  cursor: pointer;
  user-select: none;
  transition: color 0.15s;
}
.crm-secao-toggle:hover {
  color: var(--vz-primary, #405189);
}

/* === Mobile (< lg) === */
@media (max-width: 991.98px) {
  .crm-rotulos-panel {
    border-right: none;
    border-bottom: 1px solid var(--vz-border-color, #e9ebec);
  }
  .crm-rotulos-inner {
    padding: 0.75rem 0;
  }
  .crm-rotulos-lista {
    max-height: 180px;
  }
  .crm-form-inner {
    padding: 1rem 0 0;
  }
  .crm-contato-modal .modal-content {
    /* Margem menor do modal no mobile → pode ocupar mais altura. */
    max-height: calc(100dvh - 1rem);
  }
}
</style>
